/** @module SiteAdmin/CentricDrive/CentricDriveFileVersionViewController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/store/Nodes",
	"csi/table/Widget"
], function(declare, lang, Nodes, Widget) {

	return declare(Widget, {
		/**
		 * Avoid selecting file current version
		 * 
		 * @param {Context} ctx
		 * @param {FormData} fd
		 */
		_canAggregateElementDocument: function(ctx, fd) {
			// summary: Allow the aggregation of NextClouldFile Nodes only if the Type is "file"
			const currentVersion = ctx.getNode().Version;
			return currentVersion !== "";
		},

		/**
		 * Only one selection is allowed (Current Version can't be selected)
		 * 
		 * @param {FormData} fd
		 */
		_resolveView: function() {
			this.inherited(arguments);

			const fd = this.defView.getFormData();
			if (fd) {
				fd.m_fAggregateTest = lang.hitch(this, this._canAggregateElementDocument);
			}
		},

		/**
		 * @override Extension point to allow configuration of the main query level
		 * @param {QueryLevel} ql
		 */
		onCreateMainQueryLevel: function(ql) {

			ql.createCustomStore = lang.hitch(this, function(ctx) {
				return new Nodes({
					cachingStore: ctx.cache,
					requestModule: "SiteAdmin",
					requestOperation: "GetCentricDriveFileVersion",
					requestParameters: {
						"DocumentRevisionCnlId": ctx.getNode().CurrentRevision
					}
				});
			});
		},

	});
});
